module.exports = __webpack_public_path__ + "img/20190614162222QQ截图20190612163113.0f0ce79b.png";